class InfiniteScroll {
  constructor() {
    this.container = document.getElementById('infinite-scroll-container');
    if (!this.container) return;

    this.productGrid = document.getElementById('product-grid');
    this.loadMoreBtn = document.getElementById('infinite-scroll-load-more');
    this.spinner = this.container.querySelector('.infinite-scroll-spinner');
    this.statusRegion = document.getElementById('infinite-scroll-status');
    this.loading = false;
    this.nextUrl = this.container.dataset.nextUrl || null;

    if (!this.nextUrl) {
      this.container.remove();
      return;
    }

    // "Load More" button as accessible fallback
    if (this.loadMoreBtn) {
      this.loadMoreBtn.addEventListener('click', () => this.loadMore());
    }

    // IntersectionObserver as progressive enhancement for auto-load on scroll
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.loading && this.nextUrl) {
            this.loadMore();
          }
        });
      },
      { rootMargin: '300px' }
    );

    this.observer.observe(this.container);
  }

  async loadMore() {
    if (this.loading || !this.nextUrl) return;
    this.loading = true;

    if (this.spinner) this.spinner.classList.remove('hidden');
    if (this.loadMoreBtn) this.loadMoreBtn.disabled = true;

    try {
      const sectionId = this.productGrid.dataset.id;
      const separator = this.nextUrl.includes('?') ? '&' : '?';
      const url = `${this.nextUrl}${separator}section_id=${sectionId}`;

      const response = await fetch(url);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');

      // Get new product items
      const newItems = html.querySelectorAll('#product-grid > li');
      const count = newItems.length;

      newItems.forEach((item) => {
        item.classList.remove('scroll-trigger--cancel');
        this.productGrid.appendChild(item);
      });

      // Announce to screen readers
      if (this.statusRegion) {
        this.statusRegion.textContent = `${count} more products loaded.`;
      }

      // Check for next page
      const newContainer = html.getElementById('infinite-scroll-container');
      if (newContainer && newContainer.dataset.nextUrl) {
        this.nextUrl = newContainer.dataset.nextUrl;
        // Update the pagination links for SEO/accessibility
        const newPagination = html.querySelector('.pagination-wrapper');
        const currentPagination = this.container.querySelector('.pagination-wrapper');
        if (newPagination && currentPagination) {
          currentPagination.innerHTML = newPagination.innerHTML;
        }
      } else {
        this.nextUrl = null;
        this.observer.disconnect();
        this.container.remove();
      }
    } catch (error) {
      console.error('Infinite scroll error:', error);
      if (this.statusRegion) {
        this.statusRegion.textContent = 'Error loading products. Please try again.';
      }
    } finally {
      this.loading = false;
      if (this.container.parentNode) {
        if (this.spinner) this.spinner.classList.add('hidden');
        if (this.loadMoreBtn) this.loadMoreBtn.disabled = false;
      }
    }
  }
}

function initInfiniteScroll() {
  new InfiniteScroll();
}

// Re-init after facet filtering replaces the grid
if (typeof FacetFiltersForm !== 'undefined') {
  const originalRenderGrid = FacetFiltersForm.renderProductGridContainer;
  FacetFiltersForm.renderProductGridContainer = function (html) {
    originalRenderGrid(html);
    initInfiniteScroll();
  };
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initInfiniteScroll);
} else {
  initInfiniteScroll();
}
